// extracted by mini-css-extract-plugin
export default {"container":"FlowRunsHeader_container__2XYmN","text":"FlowRunsHeader_text__JXRp_"};